import type { SVGProps } from 'react';

const SvgSatelliteAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="m15.44.59-3.18 3.18c-.78.78-.78 2.05 0 2.83l1.24 1.24-.71.71-2.65-2.65-4.24 4.24 2.65 2.65-.71.71-1.24-1.25c-.78-.78-2.05-.78-2.83 0L.59 15.43c-.78.78-.78 2.05 0 2.83l3.54 3.54c.78.78 2.05.78 2.83 0l3.18-3.18c.78-.78.78-2.05 0-2.83L8.9 14.55l.71-.71 2.65 2.65 4.24-4.24-2.66-2.65.71-.71 1.24 1.24c.78.78 2.05.78 2.83 0l3.18-3.18c.78-.78.78-2.05 0-2.83L18.26.58c-.78-.78-2.04-.78-2.82.01M6.6 19.32l-1.06 1.06L2 16.85l1.06-1.06zm2.12-2.12-1.06 1.06-3.54-3.54 1.06-1.06zm9.54-9.54L17.2 8.72l-3.54-3.54 1.06-1.06zm2.12-2.12L19.32 6.6l-3.54-3.54L16.85 2zM21 14h2a9 9 0 0 1-9 9v-2c3.87 0 7-3.13 7-7m-4 0h2c0 2.76-2.24 5-5 5v-2c1.66 0 3-1.34 3-3" />
  </svg>
);
export default SvgSatelliteAlt;
